var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipse20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE9\x80\x9A\xE7\x94\xA8\xE5\x9B\xBE\xE6\xA0\x87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630572",
    x: 8.4494,
    y: 8.44971,
    width: 3.10143,
    height: 3.10143,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 66 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0111 8.12365C16.3801 6.5246 16.0858 5.31659 15.3846 4.61543C14.6835 3.91427 13.4754 3.61997 11.8764 3.98898C10.295 4.35392 8.50131 5.34489 6.92308 6.92312C5.34484 8.50136 4.35387 10.295 3.98893 11.8764C3.61992 13.4755 3.91423 14.6835 4.61538 15.3847C5.31654 16.0858 6.52455 16.3801 8.1236 16.0111C9.70503 15.6462 11.4987 14.6552 13.0769 13.077C14.6552 11.4987 15.6461 9.70507 16.0111 8.12365ZM13.8462 13.8462C17.2448 10.4475 18.278 5.97037 16.1538 3.8462C14.0297 1.72203 9.55252 2.75522 6.15385 6.15389C2.75517 9.55257 1.72198 14.0297 3.84615 16.1539C5.97033 18.2781 10.4475 17.2449 13.8462 13.8462Z",
    fill: "#00C2FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse20);
export default __webpack_public_path__ + "static/media/ellipse_20.e2e93599871246824645ff7944c80c93.svg";
export { ForwardRef as ReactComponent };